import React from 'react';
import PropTypes from 'prop-types';
const isSsr = typeof window === 'undefined';

export default function MoreAboutRoute({ extraInfo, title }) {
  return (
    <div className="otherTrainsRoute aboutCityText">
      <div className="heading">
        <h2>{title}</h2>
      </div>
      <div className="extraInfoCard">
        <p
          className="aboutCity"
          dangerouslySetInnerHTML={{
            __html: isSsr ? extraInfo : unescape(extraInfo)
          }}
        />
      </div>
    </div>
  );
}

MoreAboutRoute.propTypes = {
  fromCity: PropTypes.string.isRequired,
  toCity: PropTypes.string.isRequired,
  extraInfo: PropTypes.string.isRequired,
  title: PropTypes.string
};
